import script from "./ButtonIconNeutralSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonIconNeutralSecondary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonIconNeutralSecondary.vue?vue&type=style&index=0&id=a875a5f0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a875a5f0"]])

export default __exports__